import { useEffect } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useUser } from "src/contexts/user-context";

export const Pylon = () => {
  const { user, isEmbedded } = useUser();
  const { appPylonDisabled } = useFlags();

  const APP_ID = import.meta.env.VITE_PYLON_APP_ID ?? "";

  useEffect(() => {
    if (!appPylonDisabled && !isEmbedded) {
      // Copied from: https://docs.usepylon.com/chat/setup
      // With a few modifications to make typescript happy
      (function () {
        const e = window;
        if (e.Pylon) return;

        const t = document;
        const n = function (...rest) {
          n.e(...rest);
        } as any;
        n.q = [];
        n.e = function (e) {
          n.q.push(e);
        };
        e.Pylon = n;
        const r = function () {
          const e = t.createElement("script");
          e.setAttribute("type", "text/javascript");
          e.setAttribute("async", "true");
          e.setAttribute("src", `https://widget.usepylon.com/widget/${APP_ID}`);
          const n: any = t.getElementsByTagName("script")[0];
          n.parentNode?.insertBefore(e, n);
        };
        if (t.readyState === "complete") {
          r();
        } else if (e.addEventListener) {
          e.addEventListener("load", r, false);
        }
      })();
    }
  }, [appPylonDisabled, isEmbedded]);

  // TODO(eric.lovett): This `biome-ignore` was part of a blanket suppression so that we could
  // turn on the rule. It is probably covering up a real bug. Please fix this or replace this
  // TODO with an explanation of why we don't want all deps listed.
  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy suppression, probably a bug
  useEffect(() => {
    if (user && user.pylon_email_hash) {
      window.pylon = {
        chat_settings: {
          app_id: APP_ID,
          name: user.name,
          email: user.email,
          user_id: user.id,
          email_hash: user.pylon_email_hash || "",
        },
      };
    }
  }, [Boolean(user)]);

  return null;
};
